module.exports = __webpack_public_path__ + "404.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/404.html
// module id = 249
// module chunks = 0